import { useState, useRef } from 'react'
import html2canvas from 'html2canvas'
import { REACT_NATIVE_MESSAGE_TYPE } from '../../common/constant/page-constant'
import { addThermalPrintStyles } from '../../pages/Sales/addThermalPrintStyles'
import {
  createThermalReceiptPDF,
  printThermalReceipt,
} from '../../pages/Sales/printThermalReceipt'
import { isReactNativeWebView } from '../utils/appUtils'

export const useGeneratePDF = () => {
  const ref = useRef(null)
  const [isPrinting, setIsPrinting] = useState(false)
  const [isDownloading, setIsDownloading] = useState(false)
  const removePDFStyles = () => {
    const style = document.getElementById('pdf-font-styles')
    if (style) {
      style.remove()
    }
  }

  const generatePDF = async (shouldPrint = false) => {
    try {
      if (shouldPrint) {
        setIsPrinting(true)
      } else {
        setIsDownloading(true)
      }

      addThermalPrintStyles()
      ref.current.classList.add('print-mode')

      // Check if this is a pharmacy copy template (wider format)
      const isPharmacyCopy = ref.current.classList.contains('pharmacyCopyTemplate')

      await new Promise((resolve) => setTimeout(resolve, 1000))

      const scale = window.devicePixelRatio * 1.5 || 3
      const canvas = await html2canvas(ref.current, {
        useCORS: true,
        allowTaint: false,
        letterRendering: true,
        scale,
        height: ref.current.scrollHeight,
        width: ref.current.scrollWidth,
        backgroundColor: '#ffffff',
      })

      if (isReactNativeWebView()) {
        const dataURL = canvas.toDataURL('image/png', 1.0)
        const message = JSON.stringify({
          type: REACT_NATIVE_MESSAGE_TYPE.IMAGE_DOWNLOAD,
          data: dataURL,
        })
        window.ReactNativeWebView.postMessage(message)
      } else {
        if (shouldPrint) {
          printThermalReceipt(canvas, isPharmacyCopy)
        } else {
          createThermalReceiptPDF(canvas, isPharmacyCopy)
        }
      }
    } catch (errMsg) {
      console.error('PDF generation error:', errMsg)
    } finally {
      ref.current?.classList.remove('print-mode')
      removePDFStyles()
      setIsDownloading(false)
      setIsPrinting(false)
    }
  }

  return { ref, isPrinting, isDownloading, generatePDF }
}
